module.exports = "/_next/static/images/573486c5b36bc96643da3fb0a99b2141-mulher-perfil-segurando-cartao-lg@3x.jpg.webp";